// extracted by mini-css-extract-plugin
export default {"ctaWrapper":"c1-z","subtitle":"d1-z","wrapper":"e1-z","leftArrow":"f1-z","rightArrow":"g1-z"};